var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketplaceOzon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 218.2",
    style: {
      enableBackground: "new 0 0 1000 218.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#005BFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M610.4,0C526,0,457.6,48.8,457.6,109.1c0,60.3,68.4,109.1,152.7,109.1c84.4,0,152.7-48.8,152.7-109.1 C763.1,48.8,694.8,0,610.4,0z M610.4,167.3c-58.3,0-101.9-30.7-101.9-58.2c0-27.5,43.6-58.2,101.9-58.2 c58.3,0,101.9,30.7,101.9,58.2C712.2,136.6,668.8,167.3,610.4,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.2,0C48.9,0,0,48.8,0,109c0,60.2,48.8,109.1,109,109.2c60.2,0,109.1-48.8,109.2-109V109 C218.2,48.8,169.4,0,109.2,0z M167.3,109c0,32.1-26,58.2-58.2,58.2c-32.2,0-58.3-26-58.3-58.2c0-32.2,26-58.3,58.2-58.3 C141.2,50.8,167.3,76.8,167.3,109L167.3,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277,4.9c-15.8,0-29.1,14.4-25.9,30.7c2.4,12,13.6,20.2,25.9,20.2h71L237.5,201.6c-3.6,4.8-0.2,11.7,5.8,11.7 h173.4c12.2,0,23.5-8.2,25.9-20.2c3.3-16.4-9.1-30.7-24.9-30.7h-86.5L441.6,16.7c3.7-4.8,0.2-11.8-5.8-11.8H277z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000,30.4v175.6c0,1.6-0.6,3.2-1.6,4.5c-2.5,3.2-7.1,3.8-10.3,1.3L850.4,102.4v85.4 c0,14.1-11.4,25.5-25.5,25.5c-14.1,0-25.5-11.4-25.5-25.5V12.2c0-1.7,0.6-3.3,1.7-4.7c2.5-3.1,7.1-3.6,10.3-1l137.6,109.2V30.4 c0-14.1,11.4-25.5,25.5-25.5S1000,16.3,1000,30.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceOzon);
export default __webpack_public_path__ + "static/media/marketplace-ozon.0df2c3bd7c355fb7bf4637e232fc41d5.svg";
export { ForwardRef as ReactComponent };